import React, { useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";

import { RoutineEditTeamListItem_Routine$key } from "./__generated__/RoutineEditTeamListItem_Routine.graphql";
import { RoutineEditScreenProps } from "./RoutineEditNavigation";
import { Keyboard } from "react-native";
import { AHTeamIconCircle, ListItem, SectionHeader } from "arkh";
import { useRoutineEditState } from "../State/RoutineEditState";

export function RoutineEditTeamListItem(
  props: RoutineEditScreenProps<"RoutineEditMain"> & {
    routine: RoutineEditTeamListItem_Routine$key;
  }
) {
  const intl_tokens = useIntlTokens();
  const routine = useFragment(
    graphql`
      fragment RoutineEditTeamListItem_Routine on Routine {
        title
        ownerTeam {
          id
          name
          color
          icon
          isPrivate
        }
      }
    `,
    props.routine
  );

  const params = useRoutineEditState();

  const team = useMemo(
    () => (params.team ? params.team : routine.ownerTeam),
    [params.team, routine.ownerTeam]
  );
  if (!team) return null;

  return (
    <>
      <SectionHeader>
        <SectionHeader.Title>{intl_tokens.Team}</SectionHeader.Title>
      </SectionHeader>
      <ListItem
        isFree
        border="border-primary"
        right={<ListItem.NavArrow />}
        left={
          <AHTeamIconCircle
            color={team.color}
            type={team.icon}
            size="smallMedium"
            isPrivate={team.isPrivate}
          />
        }
        onPress={() => {
          Keyboard.dismiss();
          props.navigation.navigate("RoutineEditOwnerTeam");
        }}
      >
        <ListItem.Title>{team.name}</ListItem.Title>
      </ListItem>
    </>
  );
}
